<template>
  <dl>
    <slot />
  </dl>
</template>

<script>
export default {
  name: 'DescriptionList'
}
</script>
